"use client";

import { useEffect, useState } from "react";
import { AppShell } from "@/components/layout/AppShell";
import { LandingHero } from "@/components/assessment/LandingHero";
import { QuickStartCards } from "@/components/assessment/QuickStartCards";
import { LandingAssessmentComposer } from "@/components/assessment/LandingAssessmentComposer";
import { AssessmentInsightsSidePanel } from "@/components/chat/AssessmentInsightsSidePanel";
import type { AssessmentResult } from "@/types";

import { apiFetch } from "@/lib/api";

export default function HomePage() {
  const [latestAnalysis, setLatestAnalysis] = useState<AssessmentResult | null>(null);
  const [brief, setBrief] = useState("");

  useEffect(() => {
    async function fetchLatest() {
      try {
        const response = await apiFetch("/chat/sessions/latest/analysis");
        if (response.ok) {
          const data = await response.json();
          setLatestAnalysis(data);
        }
      } catch (error) {
        console.error("No recent analysis found for landing page");
      }
    }
    fetchLatest();
  }, []);

  return (
    <AppShell 
      sidePanel={<AssessmentInsightsSidePanel assessmentResults={latestAnalysis} />}
    >
      <main className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        <div className="mx-auto w-full max-w-4xl px-6 py-10 lg:max-w-5xl">
          <LandingHero />
          <QuickStartCards onSelect={setBrief} />
          <LandingAssessmentComposer message={brief} onMessageChange={setBrief} />
        </div>
      </main>
    </AppShell>
  );
}
